// Keenthemes' plugins
window.KTUtil = require('js/private/components/util.js');
window.KTApp = require('js/private/components/app.js');
window.KTCard = require('js/private/components/card.js');
window.KTCookie = require('js/private/components/cookie.js');
window.KTDialog = require('js/private/components/dialog.js');
window.KTHeader = require('js/private/components/header.js');
window.KTImageInput = require('js/private/components/image-input.js');
window.KTMenu = require('js/private/components/menu.js');
window.KTOffcanvas = require('js/private/components/offcanvas.js');
window.KTScrolltop = require('js/private/components/scrolltop.js');
window.KTToggle = require('js/private/components/toggle.js');
window.KTWizard = require('js/private/components/wizard.js');
require('js/private/components/datatable/core.datatable.js');
require('js/private/components/datatable/datatable.checkbox.js');
require('js/private/components/datatable/datatable.rtl.js');

// Metronic js/private/layout base js
window.KTLayoutAside = require('js/private/layout/base/aside.js');
window.KTLayoutAsideMenu = require('js/private/layout/base/aside-menu.js');
window.KTLayoutContent = require('js/private/layout/base/content.js');
window.KTLayoutFooter = require('js/private/layout/base/footer.js');
window.KTLayoutHeader = require('js/private/layout/base/header.js');
window.KTLayoutHeaderMenu = require('js/private/layout/base/header-menu.js');
window.KTLayoutHeaderTopbar = require('js/private/layout/base/header-topbar.js');
window.KTLayoutStickyCard = require('js/private/layout/base/sticky-card.js');
window.KTLayoutStretchedCard = require('js/private/layout/base/stretched-card.js');
window.KTLayoutSubheader = require('js/private/layout/base/subheader.js');

// Metronic js/private/layout extended js
window.KTLayoutScrolltop = require('js/private/layout/extended/scrolltop.js');

require('js/private/layout/initialize.js');
